import React from "react";
import { cn, formControlClass } from "./formStyles";

const SelectInput = React.forwardRef(function SelectInput(
  { className = "", invalid = false, children, ...props },
  ref
) {
  return (
    <select
      ref={ref}
      className={cn(
        formControlClass,
        invalid && "border-red-500 focus:ring-red-500",
        className
      )}
      {...props}
    >
      {children}
    </select>
  );
});

export default SelectInput;
